<template lang="pug">
.error.center-grid
    BaseSheet(color="white" elevation="none").error-container
        .text-align-center
            p.description タイムアウトが発生しました。
                br
                |大変申し訳ありませんが、最初からやり直してください。
</template>

<script setup>
    import BaseSheet from '@/components/atoms/BaseSheet.vue'
    import { useHead } from '@unhead/vue'
    import { VueHelper } from '@/helpers/vue'

    useHead({
        title: 'エラー'
    })

    VueHelper.unlock()
</script>

<style lang="stylus" scoped>
    .error
        padding-bottom: 90%

    .error-container
        min-width 328px
        min-height 194px
        padding 50px 40px
</style>
